import { createTheme } from '@mui/material/styles';

export const mainTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        text: {
          color: 'white',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        body1: {
          color: '#000',
          fontFamily: `"Ubuntu", "Helvetica", "Roboto", sans-serif`,
        },
        body2: {
          fontFamily: `"Ubuntu", "Helvetica", "Roboto", sans-serif`,
        },
      },
    },
  },
});
